import { DiagnosticAddinData } from "../models/DiagnosticAddinData";

export function resolveDiagnosticOverride(
  addinData: DiagnosticAddinData[],
  diagnosticId: string,
  deviceGroupIds: string[],
): DiagnosticAddinData | undefined {
  const candidates = addinData.filter(a => a.diagnosticId === diagnosticId);
  const override = candidates.find(a => a.groupId && deviceGroupIds.includes(a.groupId));
  return override ?? candidates.find(a => !a.groupId);
}
